export default class Config {

  public static SEARCH_DEBOUNCE_TIMEOUT = 350;

  public static getBackendUrl() {
    return process.env.REACT_APP_BACKEND_URL;
  }

  public static getAppVersion() {
    return process.env.REACT_APP_VERSION;
  }

  public static isProdEnv(): boolean {
    return process.env.REACT_APP_ENV === "production";
  }

}



// WEBPACK FOOTER //
// ./src/config.ts